import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import rice from '../../../../images/raw_material/rice.png';
import dhalimage from '../../../../images/raw_material/dhal.png';
import tomatoimage from '../../../../images/raw_material/tomato.png';

import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import {  Col, Tab, Nav } from "react-bootstrap";
import Select from 'react-select';
import DatePicker from "react-multi-date-picker";
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import axios from 'axios';

dayjs.extend(isBetween);

const getStartOfWeek = (date) => {
    const day = date.getDay(), // get the current day of the week
          diff = date.getDate() - day; // calculate the difference in days to the previous Sunday
    const startOfWeek = new Date(date.setDate(diff)); 
    startOfWeek.setHours(0, 0, 0, 0); // set to midnight
    return startOfWeek;
};

const getEndOfWeek = (date) => {
    const day = date.getDay(),
          diff = date.getDate() + (6 - day); // calculate the difference to the next Saturday
    const endOfWeek = new Date(date.setDate(diff));
    endOfWeek.setHours(23, 59, 59, 999); // set to the end of the day
    return endOfWeek;
};
const baseURL = process.env.REACT_APP_API_BASE_URL;


const Stock = () => {

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);

    // page table data fetch
    const fetchData = (filter = {}) => {
        const params = {
            ...filter,      // spread existing filter key-values
            page,           // add page number
            per_page: perPage, // add per_page
            search: searchTerm,  // add search string
            branch_id: branch_id
        };
        axios.get(`${baseURL}/stock/consumption_list`, { params: params })
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };

    // fetch data
    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage]);


    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    
    const [key, setKey] = useState('stock_consumption');

    // const tableRef = useRef(null);

    const DeleteModal = () => {
        swal.fire({
            html: `
                <div class="alert alert-danger px-2 py-2" role="alert">
                    <strong>OOPS! </strong> You're about to lose one Stock
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <p class="text-center"><b>Basmathi Rice</b></p>
                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                        <defs>
                            <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#5987dd"/>
                                <stop offset=".118" stop-color="#638bd6"/>
                                <stop offset=".316" stop-color="#7d98c3"/>
                                <stop offset=".572" stop-color="#a8aba3"/>
                                <stop offset=".871" stop-color="#e3c678"/>
                                <stop offset="1" stop-color="#ffd364"/>
                            </radialGradient>
                            <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                        </defs>
                        <g id="_27-feel_bad" data-name="27-feel bad">
                            <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                            <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                            <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                            <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="34" cy="22" r="1"/>
                            <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="16" cy="22" r="1"/>
                            <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                            <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                            <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                            <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                            <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                            <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                            <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                            <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                            <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                            <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                            <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                        </g>
                    </svg>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        })
    };

    useEffect(() => {
        const tables = document.querySelectorAll('.product_data_table');
        tables.forEach((table) => {
            if (!$.fn.dataTable.isDataTable(table)) {
                $(table).DataTable({
                    "responsive": true,
                    pageLength: 25,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        });
    }, []);


    const date_fil_options_stock = [
        { value: "all", label: "All" },
        { value: "yesterday", label: "Yesterday" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custom Date" }
    ];

    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(getStartOfWeek(new Date()));
    const [week_eddt_fil_value, setWeekEDDTFilValue] =  useState(getEndOfWeek(new Date()));
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());
    const [yest_fil_value, setYestFilValue] = useState(dayjs().subtract(1, 'day').toDate());
    const [today_fil_value, setTodayFilValue] = useState(new Date());


    useEffect(() => {
        const params = {
            date_filter: date_fil_selt_value,
        };
        if (date_fil_selt_value === 'yesterday') {
            params.start_date = dayjs(yest_fil_value).format('DD-MM-YYYY');
            params.end_date = dayjs(yest_fil_value).format('DD-MM-YYYY');
        } else if (date_fil_selt_value === 'this_week') {
            params.start_date = dayjs(week_stdt_fil_value).format('DD-MM-YYYY');
            params.end_date = dayjs(week_eddt_fil_value).format('DD-MM-YYYY');
        } else if (date_fil_selt_value === 'this_month') {
            const startOfMonth = dayjs(month_fil_value).startOf('month').format('DD-MM-YYYY');
            const endOfMonth = dayjs(month_fil_value).endOf('month').format('DD-MM-YYYY');
            params.start_date = startOfMonth;
            params.end_date = endOfMonth;
        } else if (date_fil_selt_value === 'custom') {
            params.start_date = dayjs(custom_stdt_fil_value).format('DD-MM-YYYY');
            params.end_date = dayjs(custom_eddt_fil_value).format('DD-MM-YYYY');
        }
        fetchData(params);

    }, [date_fil_selt_value, custom_stdt_fil_value, custom_eddt_fil_value, month_fil_value, week_stdt_fil_value, week_eddt_fil_value]);
    
    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Stocks</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Purchase Management</li>
                    </ol>
                </div>
            </div>

            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li">
                                <Nav.Link as={Link} to="/manage-stocks" >
                                    <i className="fa-regular fa-user me-2" />
                                    <label className="ms-2 fs-6">
                                        Manage Stock
                                    </label>

                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/manage-stocks-checklist-history" >
                                    <i className="fa-solid fa-list-check me-2" />
                                    <label className="ms-2 fs-6">
                                        Stock Checklist History
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/manage-stocks-vessels" >
                                    <i className="fa-solid fa-kitchen-set me-2" /> 
                                    <label className="ms-2 fs-6">
                                        Manage Vessel Stock
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="stock_consumption">
                                    <i className="fa-solid fa-cookie-bite me-2" /> 
                                    <label className="ms-2 fs-6">
                                        Stock Consumption
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                         
                        <Tab.Content className="pt-4">

                            <Tab.Pane eventKey="stock_consumption">
                                <div className='row mb-4'>
                                    <div className="col-lg-3 mb-2">
                                        <label className="text-black font-w500 fs-7">Date</label>
                                        <Select
                                            value={date_fil_options_stock.find(option => option.value === date_fil_selt_value)}
                                            onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                            options={date_fil_options_stock}

                                        />
                                    </div>
                                    {date_fil_selt_value === "all" && <></>}
                                    {date_fil_selt_value === "yesterday" && (
                                        <div className="col-lg-3 mb-2">
                                            <label className="text-black font-w500 fs-7">Yesterday</label>
                                            <div className='datepicker-wrapper d-flex'>
                                                <div className='input-group-text bg-transparent border-0 px-0'>
                                                    <i className='fa-solid fa-calendar-days fs-4'></i>
                                                </div>
                                                <DatePicker
                                                    value={yest_fil_value}
                                                    onChange={setYestFilValue}
                                                    format="DD-MM-YYYY"
                                                    readOnly={true}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {date_fil_selt_value === "this_week" && (
                                        <>
                                            <div className="col-lg-3 mb-2">
                                                <label className="text-black font-w500 fs-7">Start Date</label>
                                                <div className='datepicker-wrapper d-flex'>
                                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                    <DatePicker
                                                        value={week_stdt_fil_value}
                                                        onChange={setWeekSTDTFilValue}
                                                        format="DD-MM-YYYY"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-3 mb-2">
                                                <label className="text-black font-w500 fs-7">End Date</label>
                                                <div className='datepicker-wrapper d-flex'>
                                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                    <DatePicker
                                                        value={week_eddt_fil_value}
                                                        onChange={setWeekEDDTFilValue}
                                                        format="DD-MM-YYYY"
                                                        calendarPosition="top-end"
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    {date_fil_selt_value === "this_month" && (
                                        <div className="col-lg-3 mb-2">
                                            <label className="text-black font-w500 fs-7">This Month</label>
                                            <div className='datepicker-wrapper d-flex'>
                                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                <DatePicker
                                                    value={month_fil_value}
                                                    onChange={setMonthFilValue}
                                                    format="MMM-YYYY"
                                                    calendarPosition="top"
                                                    mode="single"
                                                    onlyMonthPicker={true}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {date_fil_selt_value === "custom" && (
                                        <>
                                            <div className="col-lg-3 mb-2">
                                                <label className="text-black font-w500 fs-7">Start Date</label>
                                                <div className='datepicker-wrapper d-flex'>
                                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                    <DatePicker
                                                        value={custom_stdt_fil_value}
                                                        onChange={setCustomSTDTFilValue}
                                                        format="DD-MM-YYYY"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-3 mb-2">
                                                <label className="text-black font-w500 fs-7">End Date</label>
                                                <div className='datepicker-wrapper d-flex'>
                                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                    <DatePicker
                                                        value={custom_eddt_fil_value}
                                                        onChange={setCustomEDDTFilValue}
                                                        format="DD-MM-YYYY"
                                                        calendarPosition="top-end"
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div className='d-flex flex-row gap-2 align-items-center justify-content-end mb-4'>
                                    <label style={{backgroundColor: '#edcdef'}} className='py-3 px-3 border border-gray800 rounded'></label>
                                    <label className='font-w600 text-black fs-6'> Consumption By Wastage</label>
                                </div>

                                <div className="table-container">

                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        {/* Left: Show entries dropdown */}
                                        <div>
                                            <label className="me-2">Show</label>
                                            <select
                                                className="form-select d-inline w-auto"
                                                style={{  fontSize: '0.85rem', height: '30px' }}
                                                value={perPage}
                                                onChange={(e) => {
                                                    setPerPage(Number(e.target.value));
                                                    setPage(1); // Reset to first page
                                                }}
                                            >
                                                <option value={10}>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                        </div>

                                        {/* Right: Search input */}
                                        <div>
                                            <input
                                                type="text"
                                                style={{  fontSize: '0.85rem', height: '40px' }}
                                                placeholder="Search..."
                                                className="form-control"
                                                value={searchTerm}
                                                onChange={(e) => {
                                                    setSearchTerm(e.target.value);
                                                    setPage(1); // Reset page on new search
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                        <thead>
                                            <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                <th className='min-w-100px'>Consumption Date</th>
                                                <th className='min-w-100px'>Raw Material</th>
                                                <th className='min-w-100px'>Brand / Expiry Day</th>
                                                <th className='min-w-100px text-center'>Consumption Qty</th>
                                                <th className='min-w-100px text-center'>Current Stock</th>
                                                <th className='min-w-50px text-center'>Buy Date / Qty</th>
                                                <th className='min-w-100px text-center'>Stock Level</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold fs-7">
                                            {datas.length === 0 && hasFetched ? (
                                                <tr>
                                                    <td colSpan="8" className="text-center text-muted py-2">
                                                        No data available
                                                    </td>
                                                </tr>
                                            ) : (
                                                <>
                                                    {datas.map((data, index) => (
                                                        <tr key={data.sno}>
                                                            <td>
                                                                <label className='font-w600 fs-7 text-black'>{data.formated_consumption_date}</label>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex align-items-center justify-content-start gap-2">
                                                                    <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                                                                        <div data-src={data.image_url ? data.image_url : rice} className='border rounded px-1 py-0'>
                                                                            <img src={data.image_url ? data.image_url : rice} alt={data.raw_material_name} className='cursor-pointer w-45px h-45px' />
                                                                        </div>
                                                                    </LightGallery>
                                                                    <div>
                                                                        <label className='text-black font-w400 fs-7'>{data.raw_material_name}</label>
                                                                        <div className="d-block">
                                                                            <label className="fs-8 text-dark font-w600">{data.raw_material_category_name}</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td align='center'>
                                                                {data.raw_material_brand_name ? (
                                                                    <Badge bg="info" className='fw-semibold fs-7 text-white'>{data.raw_material_brand_name}</Badge>
                                                                ) : "-"}
                                                                <div className='d-block mt-1'>
                                                                    <label className='text-black font-w400 fs-7'>{String(data.expiry_days).padStart(2, '0')} {data.expiry_days > 1 ? "Days" : "Day"}</label>
                                                                </div>
                                                            </td>
                                                            <td align='center'>
                                                                <label className='text-black font-w400 fs-7'>{String(data.consumption_quantity).padStart(2, '0')} {data.quantity_unit_name ? data.quantity_unit_name : ''}</label>
                                                            </td>
                                                            <td align='center'>
                                                                <label className='text-black font-w400 fs-7'>{String(data.current_stock).padStart(2, '0')} {data.current_stock_unit_name ? data.current_stock_unit_name : ''}</label>
                                                            </td>
                                                            <td align='center'>
                                                                <Badge bg="none" className='fw-semibold fs-7 text-danger border-danger border'>{data.last_purchase_date}</Badge>
                                                                <div className='d-block mt-1'>
                                                                    <label className='text-black font-w400 fs-7'>{String(data.purchase_quantity).padStart(2, '0')} {data.current_stock_unit_name ? data.current_stock_unit_name : ''}</label>
                                                                </div>
                                                            </td>
                                                            <td align='center'>
                                                                {data.stock_level === 0 ? (
                                                                    <Badge bg="warning" className='text-white fs-7 py-0 px-1'>Available</Badge>
                                                                ):(
                                                                    <>
                                                                    {data.stock_level === 1 ? (
                                                                        <Badge bg="success" className='text-white fs-7 py-0 px-1'>High</Badge>
                                                                    ) : (
                                                                        <Badge bg="danger" className='text-white fs-7 py-0 px-1'>Low</Badge>
                                                                    )}
                                                                    </>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </>
                                            )}

                                            {/* <tr style={{ backgroundColor: '#edcdef' }}>
                                                <td>
                                                    <label className='font-w600 fs-7 text-black'>28-Jul-2025</label>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center justify-content-start gap-2">
                                                        <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                                                            <div data-src={dhalimage} className='border rounded px-1 py-0'>
                                                                <img src={dhalimage} alt="Dhal" className='cursor-pointer w-45px h-45px' />
                                                            </div>
                                                        </LightGallery>
                                                        <div>
                                                            <label className='text-black font-w400 fs-7'>Dhal</label>
                                                            <div className="d-block">
                                                                <label className="fs-8 text-dark font-w600">Pulses</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td align='center'>
                                                    <Badge bg="info" className='fw-semibold fs-7 text-white'>IndiaGate</Badge>
                                                    <div className='d-block mt-1'>
                                                        <label className='text-black font-w400 fs-7'>100 Days</label>
                                                    </div>
                                                </td>
                                                <td align='center'>
                                                    <label className='text-black font-w400 fs-7'>5 Kg's</label>
                                                </td>
                                                <td align='center'>
                                                    <label className='text-black font-w400 fs-7'>10 Kg's</label>
                                                </td>
                                                <td align='center'>
                                                    <Badge bg="none" className='fw-semibold fs-7 text-danger border-danger border'>26-Jul-2025</Badge>
                                                    <div className='d-block mt-1'>
                                                        <label className='text-black font-w400 fs-7'>15 Kg's</label>
                                                    </div>
                                                </td>
                                                <td align='center'>
                                                    <Badge bg="warning" className='text-white fs-7 py-0 px-1'>Available</Badge>
                                                </td>
                                                <td align='center'>
                                                    <span className="text-end">
                                                        <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>Delete</span></Tooltip>}>
                                                            <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={DeleteModal}>
                                                                <span><i className="fa-solid fa-trash-can fs-6 mt-1"></i></span>
                                                            </Button>
                                                        </OverlayTrigger>
                                                    </span>
                                                </td>
                                            </tr> */}
                                        </tbody>
                                    </table>

                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        {/* Bottom left: Showing x to y of z entries */}
                                        <div>
                                            {datas.length > 0 ? (
                                                <span className="text-muted">
                                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                                                </span>
                                            ):(
                                                <span className="text-muted">
                                                    Showing 0 to 0 of 0 entries
                                                </span>
                                            )}
                                        </div>

                                        {/* Bottom right: Pagination */}
                                        <nav>
                                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                {/* Previous Button */}
                                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                                    Previous
                                                </button>
                                                </li>

                                                {/* First Page */}
                                                <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                                    1
                                                </button>
                                                </li>

                                                {/* Left Ellipsis */}
                                                {page > 4 && (
                                                <li className="page-item disabled">
                                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                </li>
                                                )}

                                                {/* Pages Around Current */}
                                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                                .map(p => (
                                                    <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                        {p}
                                                    </button>
                                                    </li>
                                                ))}

                                                {/* Right Ellipsis */}
                                                {page < totalPages - 3 && (
                                                <li className="page-item disabled">
                                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                </li>
                                                )}

                                                {/* Last Page */}
                                                {totalPages > 1 && (
                                                <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                                    {totalPages}
                                                    </button>
                                                </li>
                                                )}

                                                {/* Next Button */}
                                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                                    Next
                                                </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>

                                </div>

                            </Tab.Pane>

                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Col>
        </>
    )


}
export default Stock;